module.exports = __webpack_public_path__ + "img/product-all.8fb84038.png";